// 身份证
export const idReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

// 中文名
export const nameReg = /^[\u4E00-\u9FA5\uF900-\uFA2D·s]{2,20}$/

export const phoneReg = /^1[3-9]\d{9}$/
// eslint-disable-next-line no-useless-escape
export const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

// 1 首位不能是0  ^[1-9]
// 2 必须是 [5, 11] 位的数字  \d{4, 9}
export const qqReg = /^[1-9][0-9]{4,9}$/gim
// JS 中会自动忽略前面几个0
export const numReg = /^[0-9]*$/
// 客服链接
export const CustomerServiceUrl =
  'https://new.xlkf.xunlei.com/live800/chatClient/chatbox.jsp?companyID=8950&configID=89&enterurl=youxi.xunlei.com&robot_ud_youxi=youxi'
